import React from 'react';
import { LineVerticalStyled } from 'components/Button/LineVertical/styled';

const LineVertical = () => {
  return <LineVerticalStyled />;
};

export default LineVertical;
